import { AutoCompleteField, BooleanSelectField, CategoryNameField, CompanyNameField, CurrencyField, DateField, DeleteField, DomainField, EmailField, FieldSet, FullNameField, GenericNameField, HiddenField, InputField, IntegerField, JSONEditorField, Markdown, NumberField, ObjectCodeField, OptionField, PasswordConfirmField, PasswordField, PhoneField, ProductNameField, SelectField, StringField, SubmitField, TagsField, TextAreaField, TimeIntervalField, TimeOfDayField, TimestampField, TimezoneField, TaxIDField, UUIDField, ValidityIndicator, WebsiteURIField } from "#root/components/form/fields";
import GenericEditor, { type GenericEditorProps } from "#root/components/generic-editor";
import { Fragment, type ReactNode } from "react";
import type { ZodType } from "zod";

export type StandardEditorProps<ListRowType extends ZodType, DetailRowType extends ListRowType> = Omit<
  GenericEditorProps<ListRowType, DetailRowType>,
  "children"
> & {
  children?: ReactNode;
  buttonOptions?: {
    save?: {
      position?: "top" | "bottom";
      label?: string;
    };
    delete?: {
      position?: "top" | "bottom";
      label?: string;
    };
  };
};

export default function StandardEditor<ListRowType extends ZodType, DetailRowType extends ListRowType>(props: StandardEditorProps<ListRowType, DetailRowType>) {
  return <Impl key={props.id} {...props} />;
}

function Impl<ListRowType extends ZodType, DetailRowType extends ListRowType>({
                                                                                buttonOptions,
                                                                                children,
                                                                                ...props
                                                                              }: StandardEditorProps<ListRowType, DetailRowType>) {
  const { id, onDelete } = props;

  const { save: saveOptions = {}, delete: deleteOptions = {} } = buttonOptions || {};

  const topButtons: ReactNode[] = [];
  const bottomButtons: ReactNode[] = [];

  const saveButton = <SubmitField>{saveOptions.label || "Save"}</SubmitField>;

  switch (saveOptions.position) {
    case undefined:
    case null:
    case "bottom":
      bottomButtons.push(saveButton);
      break;
    case "top":
      topButtons.push(saveButton);
      break;
    default:
  }

  if (id !== "new" && onDelete) {
    const deleteButton = <DeleteField className="right">{deleteOptions.label || "Delete"}</DeleteField>;
    switch (deleteOptions.position) {
      case undefined:
      case null:
      case "bottom":
        bottomButtons.push(deleteButton);
        break;

      case "top":
        topButtons.push(deleteButton);
        break;
      default:
    }
  }

  return (
    <div className="standard-editor">
      <GenericEditor {...props}>
        {({ message }) => (
          <Fragment>
            {topButtons.length > 0 ? <div className="button-row">{topButtons}</div> : null}
            <FieldSet name="id" className="hidden">
              <HiddenField/>
            </FieldSet>
            {message}
            {children}
            {bottomButtons.length > 0 ? <div className="button-row">{bottomButtons}</div> : null}
          </Fragment>
        )}
      </GenericEditor>
    </div>
  );
}
